import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/home/index.vue'
const login = () => import('../views/login/index.vue')
const dashboard = () => import('../views/dashboard/index.vue')
const graph = () => import('../views/graph/index.vue')

const list = () => import('../views/lists/index.vue')
const detail = () => import('../views/details/index.vue')

const qbDynamic = () => import('../views/qbDynamic/index.vue')
const personalCenter = () => import('../views/personalCenter/index.vue')

const postureMap = () => import('../views/graph/postureMap.vue')
const equipQA = () => import('../views/graph/equipQA.vue')
const equipComparison = () => import('../views/graph/equipComparison.vue')

const fullScreen = () => import('../views/fullScreen/index.vue')

const Map = () => import('../views/map/positionIndex.vue')
const advSearch = ()=>import('../views/advSearch/index.vue')

const dataCenter = ()=>import('../views/dataCenter/resGuidance.vue')
const resGuidance = ()=>import('../views/dataCenter/resGuidance.vue')
const industryAnalysis = () => import('../views/dataCenter/industryAnalysis.vue')
const dcArchitecture = ()=>import('../views/dataCenter/architecture.vue')
const dcArchitecture2 = ()=>import('../views/dataCenter/architecture2.vue')

const monographicStudy = ()=>import('../views/monographicStudy/index.vue')

const generalTopic = ()=>import('../views/details/generalTopicDetail.vue')
const areaTopic = ()=>import('../views/details/areaTopicDeatil.vue')
const nationTopic = ()=>import('../views/details/nationTopicDetail.vue')
const timelineTopic = ()=>import('../views/details/timelineTopicDetail.vue')

const domainMatch = ()=>import('../views/domainMatch/index.vue')

const smartRead = ()=>import('../views/smartReading/index.vue')
Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'dashboard', component: dashboard },
  { path: '/home', name: 'home', component: HomeView },
  { path: '/login', name: 'login', component: login },
  { path: '/graph', name: 'graph', component: graph ,meta: { title: '军情图谱' } },
  { path: '/dataCenter', name: 'dataCenter', component: dataCenter, meta: { title: '数据中心' } },
  { path: '/qbDynamic', name: 'qbDynamic', component: qbDynamic, meta: { title: '情报动态', } },
  { path: '/personalCenter', name: 'personalCenter', component: personalCenter, meta: { title: '个人中心', } },
  { path: '/advSearch', name: 'advSearch', component: advSearch, meta: { title: '高级检索', } },
  { path: '/monographicStudy', name: 'monographicStudy', component: monographicStudy, meta: { title: '专题研究', } },

  /* 导航下拉*/
  { path: '/resGuidance', name: 'resGuidance', component: resGuidance, meta: { title: '资源导航', } },
  { path: '/industryAnalysis', name: 'industryAnalysis', component: industryAnalysis, meta: { title: '数据分析' } },
  { path: '/dcArchitecture', name: 'dcArchitecture', component: dcArchitecture, meta: { title: '俄军体系' } },
  { path: '/dcArchitecture2', name: 'dcArchitecture2', component: dcArchitecture2, meta: { title: '乌军体系' } },

  /* 列表页 */
  { path: '/orgList', name: 'org', component: list, meta: { title: '军旅文献' } },
  { path: '/expertList', name: 'expert', component: list, meta: { title: '专题研究' } },
  { path: '/qkList', name: 'qk', component: list, meta: { title: '期刊列表' } },
  { path: '/list', name: 'list', component: list, meta: { title: '列表' } },
  { path: '/imgList', name: 'img', component: list, meta: { title: '图片列表' } },
  /* 领域匹配 */
  { path: '/domainMatch', name: 'domainMatch', component: domainMatch, meta: { title: '领域匹配' } },

  /* 详情页 */
  {
    path: '/detail', name: 'detail', component: detail,
    meta: { title: '详情', bread: [{ title: '列表', path: '/list' }] }
  },
   /*专题--详情页 */
  { path: '/generalTopic', name: 'generalTopic', component: generalTopic, 
    meta: { title: '一般专题详情', bread: [{ title: '专题列表', path: '/monographicStudy' }] } 
  },
  { path: '/areaTopic', name: 'areaTopic', component: areaTopic, 
    meta: { title: '区域控制详情', bread: [{ title: '专题列表', path: '/monographicStudy' }] } 
  },
  { path: '/nationTopic', name: 'nationTopic', component: nationTopic, 
    meta: { title: '国情详情', bread: [{ title: '专题列表', path: '/monographicStudy' }] } 
  },
  { path: '/timelineTopic', name: 'timelineTopic', component: timelineTopic, 
    meta: { title: '冲突事件事件线详情', bread: [{ title: '专题列表', path: '/monographicStudy' }] } 
  },

   /* 分析工具 */
  { path: '/postureMap', name: 'postureMap', component: postureMap, meta: { title: '态势地图' }},
  { path: '/equipQA', name: 'EquipQA', component: equipQA, meta: { title: '装备问答' }},
  { path: '/equipComparison', name: 'equipComparison', component: equipComparison, meta: { title: '装备对比' }},


  { path: '/fullScreen', name: 'fullScreen', component: fullScreen, },
  { path: '/map', name: 'Map', component: Map, },
  { path: '/smartRead', name: 'smartRead', component: smartRead,meta:{title:'智能阅读'} }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
// 配置 scrollBehavior
router.scrollBehavior = (to, from, savedPosition) => {
  return { x: 0, y: 0 }; // 每次路由切换时滚动到顶部
};
export default router


// router文件夹-->index.js文件
//cv以下代码解决路由地址重复的报错问题(一劳永逸)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  document.title = '俄乌态势情报系统'
  next()
})